module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"textarea":"Topics blueprint"}}')
  delete Component.options._Ctor
}
